import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function AddService() {
  const [category, setCategory] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [price, setPrice] = useState("");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get("https://visitguru.in/api/v1/category/getCategory")
      .then((res) => {
        setCategories(res.data?.data || []);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        toast.error("Failed to load categories");
      });
  }, []);

  const handleSubmit = async () => {
    if (!category || !serviceName || !price) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("serviceName", serviceName);
      formData.append("price", price);

      const response = await axios.post(
        "https://visitguru.in/api/v1/service/addService",
        formData
      );

      if (response.status === 200 || response.data.success) {
        toast.success("Service added successfully!");
        setCategory("");
        setServiceName("");
        setPrice("");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to add service.");
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Add Service</h6>
        </div>
      </div>
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* Category Dropdown */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Category
            </label>
            <select
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.categoryName}
                </option>
              ))}
            </select>
          </div>

          {/* Service Name Input */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Service Name
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Service Name"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
            />
          </div>

          {/* Price Input */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Price
            </label>
            <input
              type="number"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-end w-full">
            <button
              type="button"
              onClick={handleSubmit}
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs mt-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
            >
              Add Service
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddService;
